export const userTypes = {
  0: "",
  1: "crm",
  2: "portal",
};
